import { Alert } from '@components/general/Alertas/Alertas';
import getUnixTimestamp from '@helpers/dates/getUnixTimestamp/getUnixTimestamp';
import { getDatosUsuario } from '@helpers/httpRequests/httpRequestsUsuarios/httpRequestsUsuarios';
import { addUsuarioLecturaVeloz } from '@helpers/httpRequests/httpRequestsUsuarios/registro/httpRequestsRegistroUsuarios';
import React, { useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';

const RegistrarUsuarioLecturaAdicional = ({idRegion, idLicencia, idPerfil, rol, idCredencial, setContextValue, contextValue}) => {

    const [formValues, setFormValues] = useState({
        nombreCompleto: '',
        apellidos: '',
        curp: '',
        alias: `UVEG-${getUnixTimestamp()}`,
        correoElectronico: ''
    })

    const [showLoader, setShowLoader]= useState(false);

    const handleOnChange = ({target}) => {
        const { name, value } = target;

        setFormValues({
            ...formValues,
            [name]: value
        })
    }

    const handleSubmit = async(e) => {
        e.preventDefault();
        //Rregistro del usuario adicional como un usuario desde pnel de administrador

        setShowLoader(true);

        try {
            const { data: datosResultadoLectura } = await addUsuarioLecturaVeloz({
                idLicencia,
                folioContrato: "UGXXXXX",
                contrasenia: 'Lectura_inteligente@Invitacion',
                nombreUsuario: formValues.correoElectronico,
                nombreCompleto: formValues.nombreCompleto,
                apellidos: formValues.apellidos,
                correo: formValues.correoElectronico,
                curp: formValues.curp,
                alias: formValues.alias,
                idRegion,
                usuarioAdicional: true,
                perfilQueInvita: idPerfil
            });
            const results = datosResultadoLectura;

            const { data } = await getDatosUsuario({
                tipoUsuario: rol,
                idCredencial: idCredencial,
                usuarioTitular: 1,
            });

            const [datosUsuarioActualizados] = data;

            setContextValue({
                ...contextValue,
                usuarioLogeado: datosUsuarioActualizados,
            });

            setShowLoader(false);

            Alert('Registro completado', 'success', 'Usuario registrado exitosamente y ha sido notificado por correo electrónico');
        } catch (error) {
            console.log(error);
            setShowLoader(false); 
        }


    }

    //PARA EL REGISTRO DEL USUARIO ADICIONAL:
    // Se puede usar el mismo proceso que cuando se genera un usuario desde panel de administrador...
    // Hay que importar las funciones necesarias, capturar la información y enviarla al backend para que se genere el usuario.
    return (
        <div className='text-start'>
            <Container>
                <Row>
                    {/* Add your component content here */}
                    <h2>Registrar Usuario Adicional</h2>
                    <span>Como beneficio adicional, puedes registrar un usuario adicional totalmente gratuito.</span>
                    <Form onSubmit={handleSubmit} className='my-5'>
                        
                        <Row className='mb-3'>
                            <Col className='col-10 col-lg-6'>
                                <Form.Group controlId="formBasicEmail">
                                    <Form.Label>Nombre completo</Form.Label>
                                    <Form.Control onChange={handleOnChange} required value={formValues.nombreCompleto} name='nombreCompleto' type="text" placeholder="Nombre completo" />
                                </Form.Group>                            
                            </Col>

                            <Col className='col-10 col-lg-6'>
                                <Form.Group controlId="formBasicEmail">
                                    <Form.Label>Apellidos</Form.Label>
                                    <Form.Control onChange={handleOnChange} required name='apellidos' value={formValues.apellidos} type="text" placeholder="Apellidos" />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className='mb-3'>
                            <Col className='col-10 col-lg-6'>
                                <Form.Group controlId="formBasicEmail">
                                    <Form.Label>{idRegion !== 1 ? 'DNI': 'CURP'}</Form.Label>
                                    <Form.Control maxLength={18} onChange={handleOnChange} required value={formValues.curp} name='curp' type="text" placeholder={idRegion !== 1 ? 'DNI' : 'CURP'} />
                                </Form.Group>             
                            </Col>

                            <Col className='col-10 col-lg-6'>
                                <Form.Group controlId="formBasicEmail">
                                    <Form.Label>Alias</Form.Label>
                                    <Form.Control disabled readOnly onChange={handleOnChange} required name='alias' type="text" value={formValues.alias}  />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className='mb-3'>

                            <Col className='col-10 col-lg-6'>
                                <Form.Group controlId="formBasicEmail">
                                    <Form.Label>Correo electrónico</Form.Label>
                                    <Form.Control onChange={handleOnChange} required value={formValues.correoElectronico} name='correoElectronico' type="email" placeholder="Correo electrónico" />
                                </Form.Group>
                            </Col>
                            <Col className='col-10 col-lg-6'>
                                <Form.Group controlId="formBasicEmail">
                                    <Form.Label>Nombre de usuario</Form.Label>
                                    <Form.Control disabled required type="text" placeholder="Nombre de usuario" readOnly value={formValues.correoElectronico} />
                                    <small className='mt-4 text-warning'>Una vez se complete el registro se podrá cambiar el nombre de usuario por uno personalizado</small>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className='mt-4'>
                            <Col >
                                <div className='gap-2 d-grid'>
                                    <Button variant="success" type="submit" disabled={showLoader}>{showLoader ? 'Registrando...' : 'Completar registro'}</Button>
                                </div>
                            </Col>
                        </Row>



                    


                       
                    </Form>
                </Row>
            </Container>
        </div>
    );
};

export default RegistrarUsuarioLecturaAdicional;